import { formatCurrency } from '@/utils/formatCurrency';

export function formatRecommendationCurrency(amount: number) {
  return formatCurrency(amount, undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
}

export function formatRecommendationCurrencyPrecise(amount: number) {
  return formatCurrency(amount, undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function formatRecommendationPct(value: number | null | undefined) {
  if (value == null || !Number.isFinite(value)) return '—';
  return `${value.toFixed(1)}%`;
}

export function adGroupLabel(adGroupId: string, map?: Map<string, string>): string {
  return map?.get(adGroupId) ?? adGroupId;
}

export function campaignDetailPath(profileId: string, campaignId: string) {
  return `/accounts/${encodeURIComponent(profileId)}/campaigns/${encodeURIComponent(campaignId)}`;
}

export function keywordRowKey(keywordId: string) {
  return `kw:${keywordId}`;
}

export function searchTermRowKey(campaignId: string, adGroupId: string, searchTerm: string) {
  return `st:${campaignId}:${adGroupId}:${searchTerm}`;
}
